import type { FaireProductEntity } from "../../entity_types/product";

export const p_d6khcuef4c: FaireProductEntity = {
  token: "p_d6khcuef4c",
  type: "product",
  name: "LM-TP1000- PRINT BABY DOLL TOP SS- LIGHT CAMO",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/009d7b5d3b3926210c5c599957a1b1cefc49d8344745563f03371fa45ba90c76.jpeg",
  galleryImageUrls: [],
  priceDollars: 14.5,
  description: "",
  tags: [],
  msrpDollars: 29,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:54.573Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
